module.exports = __webpack_public_path__ + "static/media/Imaryuk6.8cfb6eab.jpg";